// extracted by mini-css-extract-plugin
export default {"profileNavLinks":"NavList_profileNavLinks__uJyQh","active":"NavList_active__JYFiQ"};